import { Middleware } from '@floating-ui/react';

export function horizontalCenterUnderReference(): Middleware {
  return {
    name: 'horizontalCenterUnderReference',
    fn({ rects }) {
      const viewportWidth = window.innerWidth;
      const floatingWidth = rects.floating.width || 0;

      const referenceBottom = rects.reference.y + rects.reference.height;
      const y = referenceBottom + 8;

      const x = (viewportWidth - floatingWidth) / 2;

      return { x, y, data: {} };
    },
  };
}
